<template>
  <nav class="w-20 justify-between flex flex-col" :class="[paramsType == 'f' ? 'bg-blue-600' : 'bg-gray-900']" :style="introduce || showStepMenu == 7 ? { zIndex: 100, position: 'relative' } : null">
    <div class="relative mt-10 mb-10">
      <span @click="isShowUserCard = !isShowUserCard" class="cursor-pointer">
        <img
          :src="userImg"
          class="rounded-full w-10 h-10 mb-3 mx-auto object-cover"
        />
      </span>
      <div v-if="isShowUserCard" class="absolute -top-4 left-20 z-50">
        <ShadowBox :padding="false">
          <div v-if="paramsType == 'f'" class="flex px-4 pt-4 w-80">
            <div class="flex-none">
              <img
                :src="userImg"
                class="rounded-full w-12 h-16 mb-3 mx-auto object-cover"
              />
            </div>
            <div class="flex-grow p-2">
              <p class="text-gray-900">{{lang['components']['Sidebar']['info_a']}} {{ userName }} {{lang['components']['Sidebar']['info_b']}}</p>
              <p class="text-gray-400">{{ userAccount }}</p>
            </div>
          </div>
          <div v-if="paramsType == 't'" class="flex px-4 pt-4 w-80">
            <div class="flex-none">
              <img
                :src="tiktokUserImg"
                class="rounded-full w-12 h-16 mb-3 mx-auto object-cover"
              />
            </div>
            <div class="flex-grow p-2">
              <p class="text-gray-900">{{lang['components']['Sidebar']['info_a']}} {{ tiktokUserName }} {{lang['components']['Sidebar']['info_b']}}</p>
              <p class="text-gray-400">{{ tiktokUserAccount }}</p>
            </div>
          </div>
          <div class="p-4 text-right">
            <button class="button border-blue" @click="logout()">{{lang['components']['Sidebar']['logout']}}</button>
          </div>
        </ShadowBox>
      </div>
      <div class="mt-10">
        <ul>
          <!-- <li class="mb-6">
            <router-link :to="{ name: 'Post',params:{id: this.$route.params.id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="'粉絲專頁貼文'">
                  <i class="pi pi-tablet text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li> -->
          <li class="mb-6">
            <router-link :to="{ name: 'Home',params:{type: paramsType, id: this.$route.params.id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['account_text']}`">
                  <i class="pi pi-user text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li>
          <!-- <li class="mb-6">
            <router-link  :to="{ name: 'Form',params:{id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: 6874} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="'即時表單'">
                  <i class="pi pi-calendar text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li> -->
          <!-- <li class="mb-6">
            <router-link :to="{ name: 'Event',params:{id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: 6874} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="'行銷活動修改頁'">
                  <i class="pi pi-book text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li> -->
          <li v-if="viewAutoturnList" class="mb-6">
            <hr />
          </li>
          <li v-if="viewAutoturnList" class="mb-6">
            <router-link :to="{ name: 'List',params:{type: paramsType, id: this.$route.params.id, adaccount_id: this.$route.params.adaccount_id} }">
            <!-- <router-link :to="{ name: 'List',params:{id: this.$route.params.id} }"> -->
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
                :class="{ 'ring-4 ring-red-500': showStepMenu == 7 }"
              >
                <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['campaign_list_text']}`">
                  <i class="pi pi-align-justify text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li>
          <li v-if="viewCustomizeList === false || viewAutoturnList === true" class="mb-6">
            <!-- <router-link :to="{ name: 'Report',params:{id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: 632} }"> -->
            <router-link :to="{ name: 'Report',params:{type: paramsType, id: this.$route.params.id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['report_text']}`">
                  <i class="pi pi-chart-line text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li>
          <li v-if="viewCustomizeList" class="mb-6">
            <hr />
          </li>
          <li class="mb-6">
            <!-- <router-link :to="{ name: 'TargetEvent',params:{type: paramsType, id: this.$route.params.id, adaccount_id: 'act_527321240980699', campaign_id: '34807'} }"> -->
            <router-link :to="{ name: 'TargetList',params:{type: paramsType, id: this.$route.params.id, adaccount_id: this.$route.params.adaccount_id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="'標靶活動列表'">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-40 -35 190 190" style="enable-background:new 0 0 122.88 113.54" xml:space="preserve">
                    <g>
                      <path d="M51.66,10.21L51.66,10.21L51.66,10.21c5.1,0,10.01,0.74,14.65,2.11c0.74,0.22,1.49,0.46,2.25,0.72 c0.84,0.29,1.67,0.6,2.49,0.93l-3.38,6.21c-4.97-1.91-10.36-2.95-16-2.95h-0.01v0c-6.16,0-12.03,1.25-17.37,3.51 c-0.87,0.37-1.73,0.76-2.56,1.18c-4.32,2.16-8.24,5-11.62,8.38l0,0l-0.02,0.02c-1.12,1.12-2.19,2.31-3.18,3.55 c-1,1.25-1.94,2.55-2.81,3.9C9.61,44.73,7.02,53,7.02,61.87v0.01h0c0,6.16,1.25,12.03,3.51,17.37c0.37,0.87,0.76,1.73,1.18,2.56 c2.16,4.31,5,8.24,8.39,11.62l0,0l0.02,0.02c1.12,1.12,2.31,2.19,3.55,3.19c1.25,1,2.55,1.94,3.9,2.81 c6.95,4.46,15.22,7.05,24.09,7.05h0.01v0c6.16,0,12.03-1.25,17.37-3.51c0.87-0.37,1.73-0.76,2.56-1.18c4.32-2.16,8.24-5,11.62-8.38 l0.01,0l0.03-0.03c1.12-1.12,2.18-2.3,3.18-3.54c1-1.25,1.94-2.55,2.81-3.9c4.46-6.94,7.05-15.2,7.05-24.06l7.01-1.08 c0.01,0.35,0.01,0.7,0.01,1.05v0.01h0c0,7.13-1.45,13.93-4.06,20.1c-0.42,1-0.88,1.99-1.37,2.97c-2.5,5-5.79,9.54-9.7,13.45l0,0 l-0.02,0.02c-1.3,1.3-2.68,2.54-4.11,3.69c-1.44,1.16-2.95,2.25-4.51,3.25c-8.04,5.17-17.61,8.17-27.88,8.17l0,0l0,0 c-7.13,0-13.93-1.45-20.1-4.06c-1-0.42-1.99-0.88-2.97-1.37c-5-2.5-9.54-5.79-13.45-9.7l0,0l-0.02-0.03 c-1.3-1.3-2.53-2.67-3.69-4.11c-1.16-1.44-2.25-2.95-3.25-4.51C3,81.71,0,72.14,0,61.87v-0.01h0c0-7.13,1.45-13.92,4.06-20.1 c0.42-1,0.88-1.99,1.37-2.97c2.5-5,5.79-9.54,9.7-13.45l0,0l0.02-0.02c1.3-1.3,2.68-2.53,4.11-3.69c1.44-1.16,2.95-2.25,4.51-3.25 C31.82,13.21,41.39,10.21,51.66,10.21L51.66,10.21L51.66,10.21z M55.88,59.54L88.3,0l4.19,33.81l30.39,15.39L55.88,59.54 L55.88,59.54z M51.66,45.52h0.01v0c0.72,0,1.43,0.05,2.12,0.14l-3.83,7.04c-0.67,0.12-1.32,0.32-1.93,0.58 c-0.18,0.08-0.36,0.16-0.54,0.25c-0.9,0.45-1.72,1.04-2.43,1.75l0,0l-0.02,0.02c-0.23,0.23-0.44,0.47-0.65,0.72 c-0.21,0.26-0.41,0.53-0.59,0.82c-0.93,1.45-1.47,3.18-1.47,5.03v0.01l0,0c0,1.29,0.26,2.51,0.74,3.63 c0.08,0.19,0.16,0.37,0.25,0.54c0.45,0.9,1.04,1.72,1.75,2.43l0,0l0.02,0.02c0.23,0.23,0.47,0.45,0.72,0.65 c0.26,0.21,0.53,0.41,0.82,0.59c1.45,0.93,3.18,1.47,5.03,1.47h0v0c1.29,0,2.51-0.26,3.63-0.73c0.19-0.08,0.36-0.16,0.54-0.25 c0.9-0.45,1.72-1.04,2.43-1.75l0,0l0.02-0.02c0.13-0.13,0.25-0.26,0.36-0.38c0.11-0.12,0.22-0.26,0.33-0.4l8.41-1.3 c-0.18,0.64-0.4,1.27-0.66,1.87c-0.13,0.31-0.28,0.63-0.43,0.94c-0.79,1.59-1.83,3.02-3.07,4.26l0,0l-0.03,0.02 c-0.41,0.4-0.83,0.79-1.28,1.15c-0.46,0.37-0.93,0.71-1.43,1.03c-2.55,1.63-5.57,2.58-8.82,2.58h0v0c-2.26,0-4.41-0.46-6.36-1.29 c-0.31-0.13-0.63-0.28-0.94-0.43c-1.59-0.79-3.02-1.83-4.26-3.07l0,0l-0.03-0.03c-0.4-0.4-0.79-0.83-1.15-1.28 c-0.37-0.46-0.71-0.93-1.03-1.43c-1.63-2.54-2.58-5.57-2.58-8.82v-0.01h0c0-2.26,0.46-4.41,1.29-6.36 c0.13-0.31,0.28-0.63,0.43-0.94c0.79-1.58,1.83-3.02,3.07-4.25l0,0l0,0l0,0c0.41-0.41,0.85-0.8,1.31-1.17 c0.46-0.37,0.93-0.71,1.43-1.03C45.38,46.47,48.41,45.52,51.66,45.52L51.66,45.52L51.66,45.52z M51.66,27.72L51.66,27.72 L51.66,27.72c3.06,0,6.02,0.4,8.83,1.16c0.46,0.12,0.91,0.25,1.36,0.4c0.24,0.08,0.49,0.16,0.73,0.24l-3.42,6.29 c-2.38-0.68-4.9-1.05-7.51-1.05l0,0v0c-3.74,0-7.31,0.76-10.56,2.13c-0.51,0.22-1.03,0.46-1.56,0.72l-0.04,0.02 c-2.61,1.31-4.97,3.03-7.02,5.08l0,0l-0.02,0.02c-0.68,0.68-1.32,1.4-1.93,2.15c-0.61,0.76-1.18,1.55-1.71,2.37 c-2.71,4.22-4.28,9.25-4.28,14.64v0.01h0c0,3.74,0.76,7.31,2.13,10.56c0.22,0.53,0.46,1.05,0.72,1.56c1.31,2.62,3.04,5,5.1,7.06 l0,0c0.69,0.69,1.42,1.34,2.17,1.95c0.76,0.61,1.55,1.18,2.37,1.71C41.24,87.43,46.27,89,51.66,89h0.01v0 c3.74,0,7.31-0.76,10.56-2.13c0.53-0.22,1.05-0.46,1.56-0.72c2.62-1.31,5-3.04,7.06-5.1l0,0c0.69-0.69,1.35-1.42,1.95-2.17 c0.61-0.76,1.18-1.55,1.71-2.37c2.25-3.5,3.71-7.54,4.15-11.89l7.12-1.1c-0.2,4.11-1.12,8.03-2.64,11.64 c-0.28,0.66-0.58,1.32-0.91,1.96c-1.65,3.31-3.83,6.31-6.41,8.89l0,0l-0.02,0.02c-0.86,0.86-1.77,1.67-2.71,2.44 c-0.95,0.77-1.95,1.49-2.98,2.15c-5.32,3.41-11.65,5.4-18.43,5.4h0v0c-4.71,0-9.21-0.96-13.29-2.68c-0.66-0.28-1.32-0.58-1.96-0.91 c-3.31-1.65-6.31-3.83-8.89-6.41l0,0l-0.02-0.03c-0.86-0.86-1.67-1.76-2.43-2.71c-0.77-0.95-1.49-1.95-2.15-2.98 c-3.42-5.32-5.4-11.64-5.4-18.43l0-0.01h0c0-4.71,0.96-9.21,2.69-13.29c0.28-0.66,0.58-1.32,0.91-1.96 c1.65-3.31,3.83-6.31,6.41-8.89l0,0l0,0l0,0l0.02-0.02c0.86-0.86,1.76-1.67,2.71-2.43c0.95-0.77,1.95-1.49,2.98-2.15 C38.55,29.7,44.88,27.72,51.66,27.72L51.66,27.72L51.66,27.72z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </router-link>
          </li>
          <li v-if="viewCustomizeList" class="mb-6">
            <hr />
          </li>
          <li v-if="viewCustomizeList" class="mb-6">
            <router-link :to="{ name: 'CustomizeList',params:{type: paramsType, id: this.$route.params.id, adaccount_id: this.$route.params.adaccount_id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="'自定義活動列表'">
                  <!-- <i class="pi pi-list text-center my-2"></i> -->
                  <!-- <svg fill="#D1D5DB" viewBox="-8 -8 40.00 40.00" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path d="M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4H5V5zm15-2h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6zm-5-6h4v4H5v-4zm13-1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"></path>
                    </g>
                  </svg> -->
                  <!-- <svg viewBox="-15 -15 77.00 77.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" transform="matrix(1, 0, 0, 1, 0, 0)" stroke-width="1">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.288"></g>
                    <g id="SVGRepo_iconCarrier"> 
                      <g id="customize"> 
                        <g id="customize_2"> 
                          <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd" d="M10.9882 18.127C10.9882 16.811 11.8288 15.6922 13.002 15.2772V11.0986H7C6.44828 11.0986 6 11.5469 6 12.0986V36.0986C6 36.6503 6.44828 37.0986 7 37.0986H19.966C20.5183 37.0986 20.966 37.5463 20.966 38.0986C20.966 38.6509 20.5183 39.0986 19.966 39.0986H7C5.34372 39.0986 4 37.7549 4 36.0986V12.0986C4 10.4423 5.34372 9.09863 7 9.09863H13.002V7.12183C13.002 6.56954 13.4497 6.12183 14.002 6.12183C14.5543 6.12183 15.002 6.56954 15.002 7.12183V9.09863H24.002C24.5543 9.09863 25.002 9.54634 25.002 10.0986L25.0017 10.1245L25.002 10.1504V27.2176C26.185 27.628 27.0342 28.7523 27.0342 30.0752C27.0342 31.3981 26.1851 32.5211 25.002 32.9311V37.0986H41C41.5517 37.0986 42 36.6503 42 36.0986V12.0986C42 11.5469 41.5517 11.0986 41 11.0986H28.002C27.4497 11.0986 27.002 10.6509 27.002 10.0986C27.002 9.54634 27.4497 9.09863 28.002 9.09863H33.002V7.13983C33.002 6.58754 33.4497 6.13983 34.002 6.13983C34.5543 6.13983 35.002 6.58754 35.002 7.13983V9.09863H41C42.6563 9.09863 44 10.4423 44 12.0986V36.0986C44 37.7549 42.6563 39.0986 41 39.0986H25.002V41.0004C25.002 41.5527 24.5543 42.0004 24.002 42.0004C23.4497 42.0004 23.002 41.5527 23.002 41.0004V32.925C21.8288 32.5101 20.9882 31.3913 20.9882 30.0752C20.9882 28.7591 21.8288 27.6391 23.002 27.2237V11.0986H15.002V15.2712C16.1851 15.6811 17.0342 16.8042 17.0342 18.127C17.0342 19.4499 16.185 20.5742 15.002 20.9847V34.0518C15.002 34.6041 14.5543 35.0518 14.002 35.0518C13.4497 35.0518 13.002 34.6041 13.002 34.0518V20.9786C11.8288 20.5631 10.9882 19.4431 10.9882 18.127ZM14.041 19.1506C14.0281 19.1501 14.0151 19.1498 14.002 19.1498C13.9917 19.1498 13.9814 19.15 13.9712 19.1503C13.4253 19.1297 12.9882 18.6795 12.9882 18.127C12.9882 17.5622 13.4456 17.105 14.0102 17.105C14.5766 17.105 15.0342 17.562 15.0342 18.127C15.0342 18.6824 14.5925 19.1343 14.041 19.1506ZM33.002 26.9786C31.8288 26.5631 30.9882 25.4431 30.9882 24.127C30.9882 22.811 31.8288 21.6922 33.002 21.2772V14.1498C33.002 13.5975 33.4497 13.1498 34.002 13.1498C34.5543 13.1498 35.002 13.5975 35.002 14.1498V21.2712C36.1851 21.6811 37.0342 22.8042 37.0342 24.127C37.0342 25.4499 36.185 26.5742 35.002 26.9847V34.0518C35.002 34.6041 34.5543 35.0518 34.002 35.0518C33.4497 35.0518 33.002 34.6041 33.002 34.0518V26.9786ZM35.0342 24.127C35.0342 23.562 34.5766 23.105 34.0102 23.105C33.4456 23.105 32.9882 23.5622 32.9882 24.127C32.9882 24.6926 33.4463 25.151 34.0102 25.151C34.5759 25.151 35.0342 24.6927 35.0342 24.127ZM25.0342 30.0752C25.0342 29.5095 24.5759 29.0512 24.0102 29.0512C23.4463 29.0512 22.9882 29.5097 22.9882 30.0752C22.9882 30.6401 23.4456 31.0972 24.0102 31.0972C24.5766 31.0972 25.0342 30.6403 25.0342 30.0752Z" fill="#D1D5DB"></path> 
                        </g> 
                      </g> 
                    </g>
                  </svg> -->
                  <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="-120 -120 650 650" id="svg2" version="1.1" inkscape:version="0.91 r13725" sodipodi:docname="customize.svg" fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> 
                      <defs id="defs4"></defs> 
                      <sodipodi:namedview id="base" pagecolor="#cccccc" bordercolor="#666666" borderopacity="1.0" inkscape:pageopacity="0.0" inkscape:pageshadow="2" inkscape:zoom="0.24748737" inkscape:cx="35.357227" inkscape:cy="265.05517" inkscape:document-units="px" inkscape:current-layer="layer1" showgrid="false" units="px" showguides="true" inkscape:guide-bbox="true" inkscape:window-width="1920" inkscape:window-height="1056" inkscape:window-x="1920" inkscape:window-y="24" inkscape:window-maximized="1"> 
                        <sodipodi:guide position="200.71429,121.42857" orientation="1,0" id="guide23298"></sodipodi:guide> 
                      </sodipodi:namedview> 
                      <metadata id="metadata7"> 
                        <rdf:rdf> 
                          <cc:work rdf:about=""> 
                            <dc:format>image/svg+xml</dc:format> 
                            <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type> 
                            <dc:title></dc:title> 
                          </cc:work> 
                        </rdf:rdf> 
                      </metadata> 
                      <g inkscape:label="Capa 1" inkscape:groupmode="layer" id="layer1" transform="translate(0,-652.36216)"> 
                        <path style="color:#cccccc;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#cccccc;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;baseline-shift:baseline;text-anchor:start;white-space:normal;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#cccccc;solid-opacity:1;fill:#cccccc;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" d="M 289.17578 0.73828125 L 54.380859 235.5332 L 1.0996094 399.26172 L 165.19336 344.16992 L 187.53711 321.82617 C 177.68256 319.88348 158.75128 315.90115 158.21875 315.78906 L 157.85938 316.14844 L 84.302734 240.9668 L 289.17578 36.09375 L 363.54492 110.46289 L 316.17773 157.83008 L 320.19531 189.16797 L 398.90039 110.46289 L 289.17578 0.73828125 z M 281.83203 163.19336 C 270.77592 163.19336 269.37826 163.27942 267.94727 164.04688 C 265.14245 165.55111 264.85252 166.72771 263.74609 181.03125 C 263.19412 188.16694 262.55189 194.23765 262.32031 194.52148 C 262.08872 194.8053 260.18213 195.51959 258.08203 196.10742 C 252.04822 197.79633 246.3826 200.07368 240.19727 203.29883 C 237.04805 204.9409 234.21892 206.28516 233.91016 206.28516 C 233.60139 206.28516 229.29567 202.82446 224.34375 198.59375 C 213.22439 189.09388 212.91077 188.85375 211.04883 188.45898 C 208.38004 187.89314 206.15654 189.48233 197.63281 198.05664 C 189.26418 206.47494 187.92021 208.38988 188.49023 211.08203 C 188.87351 212.89217 189.17315 213.28457 198.61133 224.30664 C 202.84304 229.24851 206.30469 233.55227 206.30469 233.87109 C 206.30469 234.18993 204.96238 237.02656 203.32031 240.17578 C 200.09516 246.36111 197.81585 252.02674 196.12695 258.06055 C 195.53912 260.16065 194.8268 262.0692 194.54297 262.30078 C 194.25916 262.53237 188.18842 263.17264 181.05273 263.72461 C 166.74918 264.83104 165.57065 265.1229 164.06641 267.92773 C 163.29898 269.35871 163.21289 270.75638 163.21289 281.8125 C 163.21289 292.86861 163.29896 294.26628 164.06641 295.69727 C 165.56685 298.495 166.76575 298.79318 180.82031 299.87305 C 187.82859 300.41151 193.87887 300.94643 194.26562 301.06055 C 194.70017 301.18876 195.39204 302.81688 196.07617 305.32422 C 197.74204 311.4296 200.00473 317.0885 203.32031 323.44727 C 204.96238 326.59647 206.30469 329.43479 206.30469 329.75391 C 206.30469 330.07307 202.99913 334.19519 198.95898 338.91406 C 187.30414 352.52676 187.35285 352.44496 189.12109 356.09766 C 190.51939 358.98616 205.97014 374.16562 208.27539 374.91602 C 211.2097 375.87112 212.58085 375.0396 223.54688 365.6582 L 233.74219 356.9375 L 239.36914 359.89453 C 246.13777 363.45243 252.99071 366.22091 258.37109 367.57031 C 261.04072 368.24001 262.41868 368.81502 262.57227 369.32422 C 262.69797 369.74082 263.23863 375.81602 263.77539 382.82422 C 264.85185 396.87932 265.15026 398.07803 267.94727 399.57812 C 269.37826 400.34552 270.77592 400.43164 281.83203 400.43164 C 292.88815 400.43164 294.2858 400.34562 295.7168 399.57812 C 298.51381 398.07813 298.81221 396.87932 299.88867 382.82422 C 300.42542 375.81602 300.96578 369.751 301.08789 369.3457 C 301.23507 368.857 302.90699 368.18019 306.05078 367.33789 C 311.91978 365.76539 317.11849 363.65014 323.87891 360.08594 C 326.74416 358.57534 329.36525 357.33984 329.70312 357.33984 C 330.04101 357.33984 334.36838 360.8024 339.32031 365.0332 C 344.27224 369.2638 349.0111 373.2573 349.85156 373.9082 C 352.02278 375.5888 354.76932 375.58298 357.20898 373.89258 C 360.31805 371.73818 373.96964 357.62151 374.75 355.75391 C 376.07812 352.57521 375.58997 351.71735 366.11328 340.59961 C 361.29867 334.95134 357.35938 330.04628 357.35938 329.69922 C 357.35938 329.35217 358.59485 326.72464 360.10547 323.85938 C 363.66968 317.09895 365.78488 311.90025 367.35742 306.03125 C 368.19976 302.88746 368.8766 301.2136 369.36523 301.06641 C 369.77059 300.9443 375.83548 300.40589 382.84375 299.86914 C 396.89881 298.79268 398.09761 298.49428 399.59766 295.69727 C 400.3651 294.26628 400.45117 292.86861 400.45117 281.8125 C 400.45117 270.75638 400.36511 269.35871 399.59766 267.92773 C 398.09245 265.12109 396.91881 264.83106 382.61328 263.73242 C 374.00527 263.07134 369.43312 262.53903 369.0293 262.15039 C 368.69455 261.82822 368.01615 259.98367 367.52148 258.05273 C 366.17059 252.77943 363.67502 246.56088 360.3457 240.17578 C 358.70363 237.02656 357.35938 234.17822 357.35938 233.8457 C 357.35938 233.51317 361.19356 228.76372 365.87891 223.29102 C 375.0543 212.57378 375.89132 211.18414 374.9375 208.25391 C 374.1919 205.96332 359.00615 190.49851 356.14062 189.11133 C 352.69841 187.44499 352.05532 187.79341 340.60938 197.5293 C 334.94838 202.34453 330.06446 206.28516 329.75586 206.28516 C 329.44726 206.28516 326.60862 204.93527 323.44727 203.28516 C 317.25857 200.0549 310.0369 197.18463 304.65234 195.81445 C 302.5931 195.29045 301.21006 194.68372 301.08203 194.25 C 300.96708 193.86067 300.433 187.80905 299.89453 180.80078 C 298.81466 166.74621 298.51454 165.54731 295.7168 164.04688 C 294.28581 163.27944 292.88815 163.19336 281.83203 163.19336 z M 283.01172 230.00586 C 294.06405 230.23279 305.04385 233.9998 314.22266 241.34375 C 330.35089 254.24794 337.1023 275.01034 331.84961 295.55273 C 330.51119 300.78705 326.03202 309.55604 322.34766 314.15234 C 313.97649 324.59547 302.09068 331.30346 288.55078 333.22852 C 285.58646 333.64994 278.41448 333.79363 276.73633 333.46484 C 276.35405 333.38996 274.47776 333.07435 272.56641 332.76367 C 266.07989 331.70922 258.77774 328.75201 252.87305 324.78711 C 236.71443 313.93697 227.72241 294.03948 230.41602 275.09375 C 232.18593 262.64488 238.62336 250.60114 247.66602 242.81836 C 257.86666 234.03893 270.48575 229.74867 283.01172 230.00586 z M 70.892578 265.64258 L 133.67969 328.42969 L 73.666016 348.71094 L 51.214844 326.26172 L 70.892578 265.64258 z " transform="translate(0,652.36216)" id="edit"> 
                          <title id="title4217">edit</title> 
                        </path> 
                      </g> 
                    </g>
                  </svg>
                </button>
              </div>
            </router-link>
          </li>
          <li class="mb-6">
            <hr />
          </li>
          <li v-if="paramsType == 'f' && (viewCustomizeList === false || viewAutoturnList === true)" i class="mb-6">
            <div class="bg-red-500 absolute rounded-full w-2 h-2 right-6"></div>
            <router-link :to="{ name: 'Video',params:{type: paramsType, id: this.$route.params.id} }">
              <div
                class="
                  fill-current
                  h-8
                  w-8
                  text-gray-300
                  mx-auto
                  hover:bg-blue-900
                  rounded
                "
              >
                <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['teaching_video_text']}`">
                  <i class="pi pi-youtube text-center my-2"></i>
                </button>
              </div>
            </router-link>
          </li>
          <li v-if="viewCustomizeList === false || viewAutoturnList === true" class="mb-6">
            <div
              class="
                fill-current
                h-8
                w-8
                text-gray-300
                mx-auto
                hover:bg-blue-900
                rounded
              "
            >
              <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['about_me_text']}`" @click="isShowAbout = !isShowAbout">
                <i class="pi pi-book text-center my-2"></i>
              </button>
            </div>
            <div v-if="isShowAbout" class="absolute left-20 w-36 z-50 text-center" :class="{ '-bottom-40': paramsType == 'f', '-bottom-28': paramsType == 't'}">
              <ShadowBox :padding="false">
                <div v-if="paramsType == 'f'" class="flex px-2 pt-2 pb-2">
                  <div class="flex-grow p-2 cursor-pointer">
                    <p class="text-gray-900"  @click="download">{{lang['components']['Sidebar']['download_text']}}</p>
                  </div>
                </div>
                <div class="flex px-2 pt-2 pb-2">
                  <div class="flex-grow p-2">
                    <p class="text-gray-900">{{lang['components']['Sidebar']['line_text']}}</p>
                    <img src="https://dev-private.autoturn.net/img/L_gainfriends_2dbarcodes_GW.png" style="display: inline-block; width: 90px;">
                  </div>
                </div>
              </ShadowBox>
            </div>
          </li>
          <!-- <li class="mb-6">
            <div
              class="
                fill-current
                h-8
                w-8
                text-gray-300
                mx-auto
                hover:bg-blue-900
                rounded
              "
            >
              <button class="w-full" v-tooltip="`${lang['components']['Sidebar']['video_list']['label']}`" @click="isShowYoutube = !isShowYoutube">
                <i class="pi pi-youtube text-center my-2"></i>
              </button>
            </div>
            <div v-if="isShowYoutube" class="absolute top-80 left-20 w-80 z-50">
              <ShadowBox :padding="false">
                <div class="flex px-2 pt-2 pb-2">
                  <div class="flex-grow p-2 cursor-pointer">
                    <p class="text-gray-900" @click="toVideo(`${lang['components']['Sidebar']['video_list']['video_title_1']}`, 'https://www.youtube.com/watch?v=gmdLYCUsato&ab_channel=DZVideoStudio')">{{lang['components']['Sidebar']['video_list']['video_title_1']}}</p>
                  </div>
                </div>
                <div class="flex px-2 pt-2 pb-2">
                  <div class="flex-grow p-2 cursor-pointer">
                    <p class="text-gray-900" @click="toVideo(`${lang['components']['Sidebar']['video_list']['video_title_2']}`, 'https://www.youtube.com/watch?v=2pJreZqbFa8&ab_channel=DZVideoStudio')">{{lang['components']['Sidebar']['video_list']['video_title_2']}}</p>
                  </div>
                </div>
                <div class="flex px-2 pt-2 pb-2">
                  <div class="flex-grow p-2 cursor-pointer">
                    <p class="text-gray-900" @click="toVideo(`${lang['components']['Sidebar']['video_list']['video_title_3']}`, 'https://www.youtube.com/watch?v=bdY3eVKOF1Q&ab_channel=%E6%A2%81%E5%A4%9A%E5%A4%9A')">{{lang['components']['Sidebar']['video_list']['video_title_3']}}</p>
                  </div>
                </div>
              </ShadowBox>
            </div>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>

  <VideoDialog v-bind:videoData="videoData" v-model:show="showVideoModal" />
  <Mask :isDisplay="introduce"/>
  <HomeMask v-if="introduce" v-bind:usLangMask="selectLang" @closeMask="doCloseMaskChange" @closeForTeaching="doCloseForTeaching"/>
</template>

<script>
import { createApp } from 'vue'
import Mask from '@/components/Event/Mask.vue';
import HomeMask from '@/components/Mask/HomeMask.vue';
import ShadowBox from "@/components/ShadowBox.vue";
import VideoDialog from '@/components/Dialog/VideoDialog.vue'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "Sidebar",
  components: {
    Mask,
    HomeMask,
    ShadowBox,
    VideoDialog
  },
  props: {
    guideStepMenu: {
      type: Number,
      default: -1
    },
    lang: {
      type: Object
    },
    usLang: {
      type: String
    },
    guideOpenTeachingAgain: {
      type: String
    },
    getChangeLinkType: {
      type: String
    },
    useFbCustomizeStatusForView: {
      type: String
    }
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showStepMenu: -1,
      introduce: false,
      isShowUserCard: false,
      userName: null,
      userAccount: null,
      userImg: null,
      tiktokUserName: null,
      tiktokUserAccount: null,
      tiktokUserImg: null,
      isShowAbout: false,
      showVideoModal: false,
      videoData: {
        title: '',
        src: ''
      },
      paramsType: 'f',
      fb_in_use_num: '0_000',
      tiktok_in_use_num: '0_000',
      viewAutoturnList: false,
      viewCustomizeList: false,
      useFbAutoturnList: false,
      useFbCustomizeList: false,
      useTiktokAutoturnList: false,
      useTiktokCustomizeList: false,
      openAutoStatus: false,
      showBox: false,
      showBlock: false,
      showBudget: false,
      showKeyword: false,
      campaignList: [
        { name: "行銷活動名稱01", status: false},
        { name: "行銷活動名稱02", status: false},
      ],
      stageList:[
        { title: "極差" },
        { title: "待加強" },
        { title: "普通" },
        { title: "良好" },
        { title: "極佳" },
      ],
      stageData: {
        currentStage: 2,
        targetStage: 3
      },
      budgetGroups: [
        { name: '廣告組合 A', before: '$500', after: '$800' },
        { name: '廣告組合 B', before: '$300', after: '$200' },
        { name: '廣告組合 C', before: '$700', after: '$1000' },
        { name: '廣告組合 D', before: '$400', after: '$300' },
        { name: '廣告組合 E', before: '$600', after: '$700' },
      ],
      keywordGroups: [
        {
          name: '廣告組合 A',
          current: ['黑色運動鞋', '運動鞋男1', '運動鞋男2', '運動鞋男3', '運動鞋男4'],
          suggest: ['黑鞋男', '黑鞋女1', '黑鞋女2', '黑鞋女3', '黑鞋女4'],
        },
        {
          name: '廣告組合 B',
          current: ['折扣優惠1','折扣優惠2','折扣優惠3','折扣優惠4','折扣優惠5'],
          suggest: ['限時折扣', '今日特價1', '今日特價2', '今日特價3', '今日特價4'],
        },
      ],
    };
  },
  watch: {
    $route(v) {
      // console.log('watch route:'+JSON.stringify(v));
      console.log('watch route', v);
      console.log(v.name);

      let pageName = v.name;

      if(pageName != 'Home' && this.showStepMenu != -1){
        this.showStepMenu = -1;
      }

      console.log(v.params.type);
      let routeType = v.params.type;

      // if(routeType != 'f' && routeType != 't'){
      //   v.params.id = routeType;
      //   v.params.type = 'f';
      // } else {
        this.paramsType = routeType;
      // }
      // console.log('v.params');
      // console.log(v.params.id);
      // console.log(v.params.type);

      axios
        .post('https://test.autoturn.net/inside/api/member_info.php', Qs.stringify({
          s_code: v.params.id,
        }))
        .then((adResponse) => {
          console.log('adResponse:'+adResponse.data);
          console.log('sidebar member_info.php');
          if(adResponse.data.status == 'success'){
            this.userName = adResponse.data.return_data.name;
            this.userAccount = adResponse.data.return_data.account;
            this.userImg =  adResponse.data.return_data.img;

            this.tiktokUserName = adResponse.data.return_data.tiktok_name;
            this.tiktokUserAccount = adResponse.data.return_data.tiktok_account;
            this.tiktokUserImg =  adResponse.data.return_data.tiktok_img;

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            this.fb_in_use_num = adResponse.data.return_data.fb_in_use_num+'_'+todayForm;
            this.tiktok_in_use_num = adResponse.data.return_data.tiktok_in_use_num+'_'+todayForm;

            console.log('this.fb_in_use_num');
            console.log(this.fb_in_use_num);
            console.log('this.tiktok_in_use_num');
            console.log(this.tiktok_in_use_num);

            this.$emit('fbNum', this.fb_in_use_num);
            this.$emit('tiktokNum', this.tiktok_in_use_num);

            if(adResponse.data.return_data.first_login == 'Y' && pageName == 'Home'){
              this.introduce = true
            }

            if(adResponse.data.return_data.first_login == 'Y'){
              this.$emit('firstLoginStatus', adResponse);
            }

            this.useFbAutoturnList = adResponse.data.return_data.use_fb_autoturn_list;
            this.useFbCustomizeList = adResponse.data.return_data.use_fb_customize_list;
            this.useTiktokAutoturnList = adResponse.data.return_data.use_tiktok_autoturn_list;
            this.useTiktokCustomizeList = adResponse.data.return_data.use_tiktok_customize_list;

            if(this.paramsType == 'f'){
              this.viewAutoturnList = this.useFbAutoturnList;
              this.viewCustomizeList = this.useFbCustomizeList;

              this.$emit('sidebarFbCustomize', adResponse.data.return_data.use_experience_customize_fin);
            }

            if(this.paramsType == 't'){
              this.viewAutoturnList = this.useTiktokAutoturnList;
              this.viewCustomizeList = this.useTiktokCustomizeList;
            }
          }
        });
    },
    "guideStepMenu":function(v){
      console.log('in menu');
      console.log(v);
      console.log('$route', this.$route);
      if(v != '' && v != null && typeof v != 'undefined' && this.$route.name == 'Home'){
        this.showStepMenu = v
      } else {
        this.showStepMenu = -1
      }

      console.log('guideStepMenu this.showStepMenu');
      console.log(this.showStepMenu);
    },
    "lang":function(v){
      console.log('menu lang');
      console.log(v);
    },
    "usLang":function(v){
      console.log('menu usLang');
      console.log(v);
      this.selectLang = v
    },
    "guideOpenTeachingAgain":function(v){
      console.log('guideOpenTeachingAgain');
      console.log(v);

      let tmpStatus = v.split('_');

      console.log(tmpStatus);
      console.log(typeof tmpStatus[0]);

      if(tmpStatus[0] == 'Y'){
        this.introduce = true
      } else {
        this.introduce = false
      }
    },
    "getChangeLinkType":function(v){
      console.log('sidebar getChangeLinkType');
      console.log(this.paramsType);

      let tmpType = v.split('_');
      if(tmpType[0] == 't' || tmpType[0] == 'f'){
        this.paramsType = tmpType[0]
      }

      if(this.paramsType == 'f'){
        this.viewAutoturnList = this.useFbAutoturnList;
        this.viewCustomizeList = this.useFbCustomizeList;

        this.$emit('sidebarFbCustomize', this.viewCustomizeList);
      }

      if(this.paramsType == 't'){
        this.viewAutoturnList = this.useTiktokAutoturnList;
        this.viewCustomizeList = this.useTiktokCustomizeList;
      }
      console.log(this.paramsType);
    },
    'isShowUserCard':function(v){
      console.log('isShowUserCard');
      console.log(v);
    },
    useFbCustomizeStatusForView:function(v){
      console.log('useFbCustomizeStatusForView', v);
      let tmpStatus = v.split('_');

      if(tmpStatus[0] == 'true'){
        this.viewAutoturnList = true;
        this.viewCustomizeList = true;

        this.$emit('sidebarFbCustomize', this.viewCustomizeList);
      }
    },
  },
  methods: {
    logout(){
      // console.log("https://test.autoturn.net/inside/index.php/index/logout/"+this.$route.params.id+"?o=1");
      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout/"+this.$route.params.id+"?o=1";
    },
    download(){
      window.open("https://test.autoturn.net/inside/index.php/use_instructions/download?fn=AutoTurn_dentsu 2.0 操作手冊.pdf");
    },
    toVideo(title, src){
      this.videoData.title = title
      this.videoData.src = src

      if(src != '' && src != null && typeof src != 'undefined'){
        this.showVideoModal = true;
      }
    },
    doCloseMaskChange(v){
      // axios
      //   .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //   }))
      //   .then((adResponse) => {
      //     this.introduce = v
      //   });

      this.introduce = false;

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

      this.$emit('menuCheck', get_value);
    },
    doCloseForTeaching(){
      this.introduce = false
      
      this.$emit('closeForTeaching', false);
    }
  }
};
</script>

<style scope></style>